import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';
const title = environment ? environment.appTitle : 'Application Title';

const routes: Routes = [

    // #region rotte con autenticazione
    ...BaseRoutes.getBaseAuthentictedRoutes(
        environment,
        [
            ...BaseRoutes.getEntityRoutes(
                title,
                "carrier",
                () => import('./carrier/carrier.module').then(m => m.CarrierModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                "deliverynoteinvoicetype",
                () => import('./delivery-note-invoice-type/delivery-note-invoice-type.module').then(m => m.DeliveryNoteInvoiceTypeModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                "freightterms",
                () => import('./freight-terms/freight-terms.module').then(m => m.FreightTermsModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                "plant",
                () => import('./plant/plant.module').then(m => m.PlantModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                "storehouse",
                () => import('./storehouse/storehouse.module').then(m => m.StorehouseModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                "warehousereason",
                () => import('./ware-house-reason/ware-house-reason.module').then(m => m.WareHouseReasonModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                "warehousesettings",
                () => import('./ware-house-settings/ware-house-settings.module').then(m => m.WareHouseSettingsModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                "deliveryvehicle",
                () => import('./delivery-vehicle/delivery-vehicle.module').then(m => m.DeliveryVehicleModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                "deliverystatus",
                () => import('./delivery-status/delivery-status.module').then(m => m.DeliveryStatusModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                "deliverytravel",
                () => import('./delivery-travel/delivery-travel.module').then(m => m.DeliveryTravelModule)
            ),
            ...BaseRoutes.getDefaultRoutes(
                title,
                environment,
                true
            )
        ]
    ),
    // #endregion rotte con autenticazione

    // rotte base per la gestione degli errori
    ...BaseRoutes.getBaseErrorsRoute()
];

@NgModule({
    imports: [
        // TODO Tommy: si potrebbe creare una custom preloadin strategy per precaricare solo le rotte offline
        RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', paramsInheritanceStrategy: 'always', preloadingStrategy: PreloadAllModules }),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
